import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'counter',
})
export class CounterPipe implements PipeTransform
{
    transform(count: number): number[] {
        return new Array(count);
    }
}
